import { useCallback } from 'react';
import { useAtomCallback } from 'jotai/utils';
import { CustomCellProps } from '@antimatterhq/ui/hooks/table/useTableRows';
import Table from '@antimatterhq/ui/components/table';
import { contextMenuStateAtom } from './QueryResultsTableAtoms';
import { QueryResultsTableData } from '@/pages/explore/query/_partials/queryResultsTable/QueryResultsTableData';

export function QueryResultsTableContextMenuCell({
  item,
  column,
}: CustomCellProps<QueryResultsTableData>) {
  const value = item[column.id] !== undefined ? String(item[column.id]) : '';

  const showContextMenu = useAtomCallback(
    useCallback(
      (_get, set, e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        set(contextMenuStateAtom, {
          isOpen: true,
          position: { x: e.clientX, y: e.clientY },
          rowData: item,
          columnId: column.id,
          value,
        });
      },
      [item, column.id, value],
    ),
  );

  return (
    <div
      className="w-full cursor-pointer select-text truncate"
      onContextMenu={showContextMenu}
      data-testid={`query-results-cell-${column.id}-${item.id}`}
    >
      <Table.SafeValueWrapper value={value} />
    </div>
  );
}
